import { FlowChartButtonStats } from 'common/builder/components/chart/FlowChart/types/FlowChartButton'

export class FlowChartButtonStatsBuilder {
  private users: number | null = null
  private clicks: number | null = null
  private segmentId: string | null = null

  /**
   * Sets users count for the button stats (null if not available)
   * Used for CTR calculation
   */
  withUsers(value: number | null): FlowChartButtonStatsBuilder {
    this.users = value
    return this
  }

  /**
   * Sets total clicks count for the button stats (null if not available)
   */
  withClicks(value: number | null): FlowChartButtonStatsBuilder {
    this.clicks = value
    return this
  }

  /**
   * Sets segmentId for the button stats (null if not available)
   */
  withSegmentId(value: string | null): FlowChartButtonStatsBuilder {
    this.segmentId = value
    return this
  }

  build(): FlowChartButtonStats {
    return {
      users: this.users,
      clicks: this.clicks,
      segmentId: this.segmentId,
    }
  }
}
